import styled from '~/utils/styled';
// ---- external imports ----

import Asset from '~/containers/GameAsset';
import {
	FORM_WIDTH_PROJECTION,
	FieldInput as BaseFieldInput,
	PrimaryButton,
	createPrimaryButtonText
} from '~/authentication/AuthAssets';
// ---- internal imports ----


// region [Projection Constants]
export const INPUT_PROJECTION = { width: 632, height: 76 };
const RESET_BTN_TEXT_PROJECTION = { width: 118 };
// endregion

// region [Components]

// FieldLabel uses "NotoSans SemiBold" — differs from the shared FieldLabel ("NotoSans")
export const FieldLabel = styled(Asset.Text.withProps({
	fontSize: 32,
	projection: FORM_WIDTH_PROJECTION,
}))`
	font-family: "NotoSans SemiBold";
	color: #fff5b0;
`;

export const DescriptionText = styled(Asset.Text.withProps({
	fontSize: 32,
	projection: FORM_WIDTH_PROJECTION,
}))`
	font-family: "NotoSans ExtraBold";
	color: #fff5b0;
`;

// Input without eye button — overrides right padding from the shared base
export const FieldInput = styled(BaseFieldInput)`
	padding: 0 16px;
	font-size: 32px;
`;

export const BackToLoginLink = styled(Asset.Link.withProps({
	fontSize: 24,
	projection: FORM_WIDTH_PROJECTION,
}))`
	font-family: "NotoSans ExtraBold";
	color: #721b0c;
	text-align: left;
	text-decoration: underline;
`;

export const ResetButton = PrimaryButton;

export const ResetButtonText = createPrimaryButtonText(RESET_BTN_TEXT_PROJECTION);

// endregion
